import {
    Modal,
    Button,
    Stack,
    Text,
    Group,
} from "@mantine/core";

interface ManageSelectionModalProps {
    opened: boolean;
    onClose: () => void;
    onSelectLicenseManagers: () => void;
    onSelectContractManager: () => void;
    selectedCount: number;
    disableCMAssignment: boolean; // Whether CM assignment should be disabled
}

const ManageSelectionModal: React.FC<ManageSelectionModalProps> = ({
    opened,
    onClose,
    onSelectLicenseManagers,
    onSelectContractManager,
    selectedCount,
    disableCMAssignment
}) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Manage Selected Licenses"
            size="lg"
            centered
        >
            <Stack gap="lg">
                <Text size="sm" c="dimmed" p={8}>
                    You have selected {selectedCount} license pool{selectedCount !== 1 ? 's' : ''}.
                    Choose an action below:
                </Text>

                <Button
                    variant="light"
                    color="blue"
                    size="xl"
                    onClick={onSelectLicenseManagers}
                    fullWidth
                >
                    <Group justify="space-between" >
                        <div>
                            <Text fw={600}>Assign License Managers</Text>
                            <Text size="xs">
                                Assign one or more License Managers to manage the selected license pool(s).
                            </Text>
                        </div>
                    </Group>
                </Button>

                <Button
                    variant="light"
                    color="orange"
                    size="xl"
                    onClick={onSelectContractManager}
                    fullWidth
                    disabled={disableCMAssignment}
                >
                    <Group justify="space-between" style={{ width: '100%' }}>
                        <div>
                            <Text fw={600}>Assign Dante product development partner</Text>
                            <Text size="xs">
                                {disableCMAssignment
                                    ?
                                    "Dante development partner assignment is only available through parent account view."
                                    : "Assign the selected license pool(s) to your Dante product development partner."
                                }
                            </Text>
                        </div>
                    </Group>
                </Button>

                <Button
                    variant="default"
                    onClick={onClose}
                    fullWidth
                    mt="md"
                >
                    Cancel
                </Button>
            </Stack>
        </Modal>
    );
};

export default ManageSelectionModal;
